import { pipe, debounce } from 'overmind';
import {
  getSearchResult,
  lengthGreaterThan,
  setQuery,
  getSearchCount,
  resetSearchCount,
} from '#store/namespaces/search/operators';
import { Context } from '#store/overmind';
import { State } from './state'; // Ensure you import the State type

const MIN_QUERY_LENGTH = 1;

export type QueryParams = {
  query: string;
};

export const search = pipe(
  setQuery,
  lengthGreaterThan(0),
  debounce(500),
  getSearchResult
);

export const reset = ({ state }: Context) => {
  state.search.loading = false;
  state.search.query = '';
  state.search.result = [];
};

export const fetchCountDebounced = pipe(debounce(500), getSearchCount);

export const resetCountDebounced = pipe(debounce(500), resetSearchCount);

export const updateFacetFilters = (
  { state, actions }: Context,
  filters: Partial<State['filters']>
) => {
  state.search.filters = {
    ...state.search.filters,
    ...filters,
  };

  const { query } = state.search;

  const hasQuery = query.length >= MIN_QUERY_LENGTH;
  const hasFilters = Object.values(state.search.filters).some((filterValue) => {
    if (filterValue instanceof Set) {
      return filterValue.size > 0;
    }
    return false;
  });

  state.search.countResult.loading = true;
  if (hasQuery || hasFilters) {
    actions.search.fetchCountDebounced();
  } else {
    actions.search.resetCountDebounced();
  }
};
